export const VIDEO_CALL_CONTAINER_ID_PREFIX = 'att_publisher_';
